<template>
	<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 279 280" style="enable-background:new 0 0 279 280;" xml:space="preserve">
		<g id="Group_12374" transform="translate(-661 -923)">
			<path id="Path_2536" class="st0" d="M800.5,923.6c77,0,139.5,62.7,139.5,140s-62.5,140-139.5,140S661,1141,661,1063.6S723.5,923.6,800.5,923.6z"/>
		</g>
		<path class="st1" d="M162.8,230.9c0.5-0.1,1-0.3,1.5-0.4c7.4-1,11.3-5.1,11.4-12.6c0.2-8.1,0.1-16.3-0.1-24.4
			c-0.2-12.5,1.1-24.7,4.7-36.7c2.2-7.4,2-15,1.7-22.7c-0.4-12-0.1-24-0.2-36c0-2.2-0.3-4.5-1.1-6.5c-1.8-4.7-4.7-6.2-12.2-7.1
			c0-4.4,0-8.7,0-13.5c2.4,0,4.8,0.2,7-0.1c1.1-0.2,2.9-1.4,2.9-2.2c0.1-5.2,0.1-10.4-0.4-15.5c-0.3-3.5-2.7-5.3-6.2-5.6
			c-2.2-0.2-4.5-0.3-6.7-0.3c-19.5,0-39,0-58.5,0c-8.5,0-11.5,3.1-11.5,11.6c0,8.4,0,16.9,0,25.7c-7.8-0.7-12.8,2.6-14.7,10
			c0-16.1,0-32.1,0-48.2c34.1,0,68.2,0,102.3,0c0,61.4,0,122.9,0,184.4C176.2,230.9,169.5,230.9,162.8,230.9z"/>
		<path class="st1" d="M80.6,143.6c3.5,17.7,7.9,35.3,6.6,53.6c-0.4,6-0.1,12-0.1,18c0,10.4,2,13.1,11.7,15.8c-6.1,0-12.2,0-18.3,0
			C80.6,201.8,80.6,172.7,80.6,143.6z"/>
		<path class="st1" d="M100.1,230.9c0.9-0.1,1.8-0.4,2.7-0.4c18.9,0,37.9,0,56.8,0c0.9,0,1.8,0.2,2.7,0.4
			C141.5,230.9,120.8,230.9,100.1,230.9z"/>
		<path class="st1" d="M131.5,89.3c12.5,0,25,0,37.5,0c6.1,0,8.7,2.6,8.7,8.7c0.1,14.5,0.6,29.1,0.2,43.6c-0.2,6.8-1.9,13.6-3.5,20.3
			c-3.3,14.1-3.2,28.4-3,42.8c0.1,4.5,0.3,9,0,13.4c-0.3,5.3-3.2,7.8-8.5,7.8c-11,0.1-21.9,0-32.9,0c-9.9,0-19.9,0-29.8,0
			c-5.9,0-8.5-2.3-8.6-8.2c-0.3-13.4,0.1-26.9-0.7-40.3c-0.4-7.5-2.5-15-3.7-22.5c-0.8-5.2-2-10.4-2.1-15.6
			c-0.3-13.9-0.1-27.9-0.1-41.8c0-5.6,2.9-8.3,8.5-8.3C106.1,89.2,118.8,89.3,131.5,89.3z M131.5,100.1c-10.6,0-21.1,0-31.7,0
			c-4.3,0-5.7,1.3-5.7,5.6c0,8.9,0,17.7,0,26.6c0,4.3,1.4,5.6,5.7,5.6c21.1,0,42.2,0,63.4,0c4.4,0,5.7-1.3,5.7-5.6
			c0-8.9,0-17.7,0-26.6c0-4.3-1.4-5.6-5.7-5.6C152.6,100.1,142,100.1,131.5,100.1z M162.1,215.9c0-14.1,0-28,0-41.9
			c-4.9,0-9.6,0-14.3,0c0,14.1,0,28,0,41.9C152.7,215.9,157.3,215.9,162.1,215.9z M138.7,164.1c0-5.5,0-10.8,0-16.1
			c-4.9,0-9.6,0-14.3,0c0,5.5,0,10.8,0,16.1C129.3,164.1,133.9,164.1,138.7,164.1z M138.7,199.9c-4.9,0-9.6,0-14.3,0
			c0,5.5,0,10.8,0,16.2c4.9,0,9.5,0,14.3,0C138.7,210.6,138.7,205.3,138.7,199.9z M124.2,189.9c4.9,0,9.6,0,14.4,0
			c0-5.3,0-10.5,0-15.8c-4.9,0-9.7,0-14.4,0C124.2,179.5,124.2,184.6,124.2,189.9z M100.7,164.1c5,0,9.7,0,14.4,0c0-5.5,0-10.8,0-16
			c-4.9,0-9.6,0-14.4,0C100.7,153.5,100.7,158.6,100.7,164.1z M162.1,164.1c0-5.4,0-10.8,0-16.1c-4.9,0-9.6,0-14.3,0
			c0,5.5,0,10.8,0,16.1C152.7,164.1,157.3,164.1,162.1,164.1z M115.3,199.9c-5,0-9.7,0-14.4,0c0,5.5,0,10.8,0,16c5,0,9.7,0,14.4,0
			C115.3,210.5,115.3,205.4,115.3,199.9z M115.1,190c0-5.6,0-10.8,0-15.9c-4.9,0-9.6,0-14.2,0c0,5.5,0,10.7,0,15.9
			C105.7,190,110.3,190,115.1,190z"/>
		<path class="st1" d="M162.9,53c0,10.1,0,20.2,0,30.6c-20.6,0-41.2,0-62.2,0c0-2.5,0-5,0-7.5c0-6.4,0-12.8,0-19.2
			c0-2.6,1.1-4.2,3.7-4.2c19.3,0,38.6,0,57.9,0C162.4,52.7,162.6,52.8,162.9,53z M157.3,69.6c-17,0-33.7,0-50.4,0c0,1.6,0,2.9,0,4.3
			c16.9,0,33.6,0,50.4,0C157.3,72.4,157.3,71.1,157.3,69.6z M157.3,58.2c-12.1,0-23.9,0-35.8,0c0,1.6,0,3.1,0,4.6c12,0,23.8,0,35.8,0
			C157.3,61.2,157.3,59.9,157.3,58.2z M106.7,62.7c2.5,0,4.8,0,7,0c0-1.6,0-3,0-4.5c-2.4,0-4.7,0-7,0
			C106.7,59.8,106.7,61.2,106.7,62.7z"/>
		<path class="st1" d="M168.5,52.8c4.3-0.1,4.6,0.1,4.8,4c0.1,2.9,0,5.8,0,9c-1.6,0-3.1,0-4.8,0C168.5,61.4,168.5,57.2,168.5,52.8z"/>
		<g>
			<path class="st2" d="M108.2,232.4c-0.4,0-0.8,0-1.2,0c-9.7-2.7-11.7-5.4-11.7-15.8c0-6-0.4-12,0.1-18c1.3-18.3-3.1-35.9-6.6-53.6
				c0-16.3,0-32.6,0-48.9c2-7.5,7-10.8,14.7-10c0-8.9,0-17.3,0-25.7c0-8.6,3-11.6,11.5-11.6c19.5,0,39,0,58.5,0c2.2,0,4.5,0.1,6.7,0.3
				c3.5,0.3,5.8,2.1,6.2,5.6c0.5,5.1,0.5,10.3,0.4,15.5c0,0.8-1.8,2-2.9,2.2c-2.3,0.3-4.6,0.1-7,0.1c0,4.7,0,9.1,0,13.5
				c7.5,0.9,10.4,2.4,12.2,7.1c0.8,2,1,4.3,1.1,6.5c0.1,12-0.2,24,0.2,36c0.3,7.7,0.5,15.3-1.7,22.7c-3.5,12-4.9,24.2-4.7,36.7
				c0.1,8.1,0.3,16.3,0.1,24.4c-0.2,7.5-4.1,11.5-11.4,12.6c-0.5,0.1-1,0.3-1.5,0.4c-0.2,0-0.4,0-0.6,0c-0.9-0.1-1.8-0.4-2.7-0.4
				c-18.9,0-37.9,0-56.8,0C110,232.1,109.1,232.3,108.2,232.4z M139.6,90.8c-12.7,0-25.4,0-38.1,0c-5.6,0-8.5,2.8-8.5,8.3
				c0,13.9-0.2,27.9,0.1,41.8c0.1,5.2,1.3,10.4,2.1,15.6c1.2,7.5,3.3,14.9,3.7,22.5c0.7,13.4,0.4,26.8,0.7,40.3
				c0.1,5.9,2.7,8.2,8.6,8.2c9.9,0,19.9,0,29.8,0c11,0,21.9,0,32.9,0c5.4,0,8.2-2.5,8.5-7.8c0.3-4.5,0.1-8.9,0-13.4
				c-0.2-14.3-0.3-28.7,3-42.8c1.6-6.7,3.3-13.5,3.5-20.3c0.4-14.5,0-29.1-0.2-43.6c-0.1-6.2-2.7-8.7-8.7-8.7
				C164.6,90.8,152.1,90.8,139.6,90.8z M171,54.5c-0.3-0.2-0.5-0.3-0.7-0.3c-19.3,0-38.6-0.1-57.9,0c-2.6,0-3.7,1.7-3.7,4.2
				c0,6.4,0,12.8,0,19.2c0,2.5,0,5,0,7.5c21,0,41.6,0,62.2,0C171,74.7,171,64.6,171,54.5z M176.6,54.3c0,4.4,0,8.6,0,12.9
				c1.7,0,3.2,0,4.8,0c0-3.1,0.1-6,0-9C181.2,54.4,180.9,54.2,176.6,54.3z"/>
			<path class="st2" d="M139.6,101.7c10.6,0,21.1,0,31.7,0c4.3,0,5.7,1.3,5.7,5.6c0,8.9,0,17.7,0,26.6c0,4.3-1.3,5.6-5.7,5.6
				c-21.1,0-42.2,0-63.4,0c-4.3,0-5.7-1.3-5.7-5.6c0-8.9,0-17.7,0-26.6c0-4.2,1.4-5.6,5.7-5.6C118.5,101.7,129,101.7,139.6,101.7z
				 M171.4,134c0-9.2,0-18,0-27c-21.4,0-42.5,0-63.7,0c0,9.1,0,18,0,27C129,134,150.1,134,171.4,134z"/>
			<path class="st2" d="M170.2,217.5c-4.8,0-9.4,0-14.3,0c0-13.9,0-27.8,0-41.9c4.6,0,9.3,0,14.3,0
				C170.2,189.4,170.2,203.4,170.2,217.5z"/>
			<path class="st2" d="M146.8,165.7c-4.8,0-9.4,0-14.3,0c0-5.3,0-10.6,0-16.1c4.7,0,9.4,0,14.3,0
				C146.8,154.9,146.8,160.2,146.8,165.7z"/>
			<path class="st2" d="M146.8,201.5c0,5.4,0,10.7,0,16.2c-4.8,0-9.5,0-14.3,0c0-5.3,0-10.6,0-16.2
				C137.2,201.5,141.9,201.5,146.8,201.5z"/>
			<path class="st2" d="M132.3,191.4c0-5.3,0-10.4,0-15.8c4.8,0,9.5,0,14.4,0c0,5.3,0,10.5,0,15.8
				C141.9,191.4,137.2,191.4,132.3,191.4z"/>
			<path class="st2" d="M108.8,165.6c0-5.5,0-10.6,0-16c4.8,0,9.5,0,14.4,0c0,5.2,0,10.5,0,16C118.5,165.6,113.8,165.6,108.8,165.6z"
				/>
			<path class="st2" d="M170.2,165.7c-4.8,0-9.4,0-14.3,0c0-5.3,0-10.6,0-16.1c4.7,0,9.4,0,14.3,0
				C170.2,154.9,170.2,160.2,170.2,165.7z"/>
			<path class="st2" d="M123.4,201.5c0,5.4,0,10.6,0,16c-4.7,0-9.4,0-14.4,0c0-5.2,0-10.5,0-16C113.7,201.5,118.4,201.5,123.4,201.5z"
				/>
			<path class="st2" d="M123.2,191.5c-4.8,0-9.4,0-14.2,0c0-5.3,0-10.5,0-15.9c4.6,0,9.3,0,14.2,0
				C123.2,180.7,123.2,185.9,123.2,191.5z"/>
			<path class="st2" d="M165.4,71.1c0,1.5,0,2.8,0,4.3c-16.8,0-33.5,0-50.4,0c0-1.4,0-2.8,0-4.3C131.7,71.1,148.4,71.1,165.4,71.1z"/>
			<path class="st2" d="M165.4,59.8c0,1.6,0,3,0,4.6c-11.9,0-23.7,0-35.8,0c0-1.5,0-2.9,0-4.6C141.5,59.8,153.3,59.8,165.4,59.8z"/>
			<path class="st2" d="M114.8,64.3c0-1.6,0-2.9,0-4.5c2.4,0,4.6,0,7,0c0,1.5,0,2.9,0,4.5C119.6,64.3,117.4,64.3,114.8,64.3z"/>
		</g>
		<path class="st1" d="M163.3,132.5c-21.3,0-42.4,0-63.7,0c0-9,0-17.9,0-27c21.2,0,42.3,0,63.7,0C163.3,114.4,163.3,123.3,163.3,132.5
			z"/>
	</svg>
</template>
<script>
export default {
	name: 'posSvg',
}
</script>

<style scoped>
/* eslint-disable */
.st0 {
	fill: var(--iconsColor1); 
}
.st2,
.st1 {
	fill: var(--iconsColor2); 
}
svg {
	width: 100%;
	height: 100%;
}
</style>